export enum Routes {
	HOME = 'home',
	QUESTION = 'question',
	FORM = 'form',
	RESULTS = 'results'
}